import { useState } from "react";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import { useSelector } from "react-redux";

function FilterModal({
  onClose,
  applyFilters,
  selectedFilters,
  filtersObj,
  loading2 = false,
}) {
  const [activeTab, setActiveTab] = useState(`#tab1`);
  const [selectedVal, setSelectedVal] = useState(selectedFilters);
  const [warningMsg, setWarningMsg] = useState("");
  const { filterOptions, loading } = useSelector((x) => x?.filter);
  const handleOutsideClick = (e) => {
    if (e.target.id === "modal-overlay") {
      onClose();
    }
  };

  const handleFilterChange = (filterKey, value) => {
    let arr = [];
    if (value) {
      arr = value.split(",");
    }
    setSelectedVal((prevState) => ({
      ...prevState,
      [filterKey]: arr,
    }));
  };

  const handleDateChange = (filterKey, date) => {
    setWarningMsg("");
    setSelectedVal((prevState) => ({
      ...prevState,
      [filterKey]: date,
    }));
  };

  const onClickApply = () => {
    for (let filter of filtersObj) {
      if (filter?.type === "date") {
        if (
          (selectedVal[filter.key]?.from && !selectedVal[filter.key]?.to) ||
          (!selectedVal[filter.key]?.from && selectedVal[filter.key]?.to)
        ) {
          setWarningMsg("Select both dates to apply filter");
          return;
        }
      }
    }
    applyFilters(selectedVal);
  };

  const clearFilterValue = () => {
    setWarningMsg("");
    const resetFilters = filtersObj.reduce((acc, filter) => {
      acc[filter.key] = filter.type === "date" ? null : [];
      return acc;
    }, {});
    setSelectedVal(resetFilters);
  };

  return (
    <div
      className="apply-filter-popup af-popup-open"
      id="modal-overlay"
      onClick={handleOutsideClick}
    >
      <div className="tabs apply-filter-popup-body">
        <div className="apply-f-left">
          <div className="apply-f-title">Filter by</div>
          <ul className="tab-links">
            {filtersObj &&
              filtersObj.map((filter, index) => (
                <li
                  key={filter.key}
                  className={`${activeTab === `#tab${index + 1}` && "active"}`}
                >
                  <a onClick={() => setActiveTab(`#tab${index + 1}`)}>
                    {filter.label}
                  </a>
                  <span className="badge text-dark">
                    {selectedVal[filter.key]?.length ||
                      (filter.type === "date" && selectedVal[filter.key]
                        ? "1"
                        : "")}
                  </span>
                </li>
              ))}
          </ul>
          <div className="apply-f-btns">
            <button
              type="button"
              className="apply-f-btn"
              onClick={onClickApply}
            >
              Apply
            </button>
            <button
              type="button"
              className="apply-f-clear-btn"
              onClick={clearFilterValue}
            >
              Clear
            </button>
          </div>
          <span className="text-danger">{warningMsg}</span>
        </div>
        {loading || loading2 ? (
          <div>Loading...</div>
        ) : (
          <div className="tab-content">
            <div className="text-end w-100">
              <button className="close-button bg-transparent" onClick={onClose}>
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            {filtersObj &&
              filtersObj.map((filter, index) => (
                <div
                  key={filter.key}
                  id={`tab${index + 1}`}
                  className={`tab ${activeTab === `#tab${index + 1}` && "active text-dark bg-transparent"}`}
                >
                  {filter.type === "date" ? (
                    <div className="date no-apply-f-datepicker">
                      <div className="date_section">
                        <span className="date-label">From Date</span>{" "}
                        <DatePicker
                          selected={selectedVal[filter.key]?.from || null}
                          onChange={(date) =>
                            handleDateChange(filter.key, {
                              ...selectedVal[filter.key],
                              from: date,
                            })
                          }
                          selectsStart
                          startDate={selectedVal[filter.key]?.from}
                          maxDate={selectedVal[filter.key]?.to}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="dd/MMM/yyyy"
                        />
                      </div>
                      <div className="date_section">
                        <span className="date-label">To Date</span>{" "}
                        <DatePicker
                          selected={selectedVal[filter.key]?.to || null}
                          onChange={(date) =>
                            handleDateChange(filter.key, {
                              ...selectedVal[filter.key],
                              to: date,
                            })
                          }
                          selectsEnd
                          startDate={selectedVal[filter.key]?.from}
                          endDate={selectedVal[filter.key]?.to}
                          minDate={selectedVal[filter.key]?.from}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="dd/MMM/yyyy"
                          className="datepicker-input"
                        />
                      </div>
                    </div>
                  ) : filter.type === "text" ? (
                    <div className="search-box relative d-flex flex-col">
                      <input
                        type="text"
                        className="form-control"
                        value={selectedVal[filter.key] ?? ""}
                        onChange={(e) =>
                          handleFilterChange(filter.key, e.target.value)
                        }
                      />
                      <button type="button" className="search-btn absolute">
                        <img src="/images/search-icon.svg" alt="" />
                      </button>
                      <p>{`Can enter multiple Ids seperated by comma (,)`}</p>
                    </div>
                  ) : filter.type === "customDropDown" ? (
                    <MultiSelect
                      onChange={(value) =>
                        handleFilterChange(filter.key, value)
                      }
                      options={
                        filter?.filterOptions?.map((i) => {
                          return {
                            label: i,
                            value: i,
                          };
                        }) || []
                      }
                      defaultValue={selectedVal[filter.key]}
                      largeData={true}
                    />
                  ) : filter.type === "customSingleDropDown" ? (
                    <MultiSelect
                      onChange={(value) =>
                        handleFilterChange(filter.key, value)
                      }
                      options={
                        filter?.filterOptions?.map((i) => {
                          return {
                            label: i,
                            value: i,
                          };
                        }) || []
                      }
                      defaultValue={selectedVal[filter.key]}
                      largeData={true}
                      singleSelect={true}
                    />
                  ) : (
                    <MultiSelect
                      onChange={(value) =>
                        handleFilterChange(filter.key, value)
                      }
                      options={
                        filterOptions[filter.key]?.map((i) => {
                          const key = Object.keys(i)[0];
                          return {
                            label: `${key} - ${i[key]}`,
                            value: key,
                          };
                        }) || []
                      }
                      defaultValue={selectedVal[filter.key]}
                      largeData={true}
                    />
                  )}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}

export { FilterModal };
